import { createFinanceForYear as createFinanceForYearImpl } from "./customers.service";

/** Typed wrapper: financeId targets the record to update when provided. */
export const createFinanceForYear = createFinanceForYearImpl as (
  companyId: string,
  customerId: string,
  year: number,
  data: object,
  financeId?: string | null
) => ReturnType<typeof createFinanceForYearImpl>;
